import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Blog, BlogService } from '../services/blog.service';

export const singleBlogResolver: ResolveFn<Blog> = (route) => {
  const slug = route.paramMap.get('slug')!;
  return inject(BlogService).getBlogBySlug(slug);
};

export const blogListResolver: ResolveFn<{
  results: Blog[];
  next: string | null;
}> = () => {
  return inject(BlogService).getBlogs(1, 4);
};
